export default "__VITE_ASSET__4038a1f2__"